import { c as _c } from "react/compiler-runtime";
import { useContext } from 'react';
import { APIDestination } from '../../../../../../../../../typings/Destination.interface';
import { APISource } from '../../../../../../../../../typings/Source.interface';
import { APIWebhook } from '../../../../../../../../../typings/Webhook.interface';
import { capitalizeFirstLetter } from '../../../../../../utils';
import { useDialog } from '../../../../../common/Dialog';
import { useToasts } from '../../../../../common/Toast';
import { GlobalContext } from '../../../../../contexts/GlobalContext';
import ConfirmDeleteDialog from '../../ConfirmDeleteDialog';
import { ResourcesContext } from '../../ResourcesContext';
const configs = {
  webhooks: 'connection',
  destinations: 'destination',
  sources: 'source'
} as const;
const useOnDelete = (type, mutate) => {
  const $ = _c(8);
  const {
    mutateResourceType
  } = useContext(ResourcesContext);
  const {
    addToast
  } = useToasts();
  const showDialog = useDialog();
  const {
    HookdeckAPI
  } = useContext(GlobalContext);
  const label = configs[type];
  let t0;
  if ($[0] !== HookdeckAPI || $[1] !== addToast || $[2] !== label || $[3] !== mutate || $[4] !== mutateResourceType || $[5] !== showDialog || $[6] !== type) {
    t0 = resource => {
      const apply = () => HookdeckAPI[type].delete(resource.id).then(() => {
        addToast("success", `Deleted ${label} ${"full_name" in resource ? resource.full_name : resource.name}`);
        mutateResourceType("webhooks", resource, true);
        mutate?.();
      }).catch(() => {
        addToast("error", `Failed to delete webhook ${"full_name" in resource ? resource.full_name : resource.name}`);
      });
      showDialog(() => {
        apply();
      }, _temp, {
        danger: true,
        title: `Delete ${capitalizeFirstLetter(label)}`,
        submit_label: `Delete ${capitalizeFirstLetter(label)}`,
        submit_icon: "delete",
        cancel_label: `Keep ${capitalizeFirstLetter(label)}`,
        message: <ConfirmDeleteDialog text={`By deleting this ${label}, no events will be accepted or delivered anymore. Are you sure?`} />
      });
    };
    $[0] = HookdeckAPI;
    $[1] = addToast;
    $[2] = label;
    $[3] = mutate;
    $[4] = mutateResourceType;
    $[5] = showDialog;
    $[6] = type;
    $[7] = t0;
  } else {
    t0 = $[7];
  }
  const onDelete = t0;
  return onDelete;
};
export default useOnDelete;
function _temp() {
  return null;
}